import { MultiPolygon, Polygon, Point, LineString } from 'geojson';

export const validateGeoJson = (geoJson: Polygon | MultiPolygon | Point | LineString): boolean => {
    return geoJson.type === 'Polygon' || geoJson.type === 'MultiPolygon';
};
